exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".category-edit[data-v-a726f9fe]{padding:20px}.container[data-v-a726f9fe]{max-width:500px;background:#fff;padding:30px;border-radius:4px;box-shadow:0 2px 4px rgba(0,0,0,.1)}h3[data-v-a726f9fe]{margin:0 0 30px;color:#333}.el-form-item[data-v-a726f9fe]:last-child{margin-bottom:0}.el-button[data-v-a726f9fe]{margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-a726f9fe&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/course/categoryEdit.vue
// module id = 614
// module chunks = 0